var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.998 16a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.998 9.4c.328 0 .6-.272.6-.6v-4c0-.328-.272-.6-.6-.6-.328 0-.6.272-.6.6v4c0 .328.272.6.6.6zM9.733 10.896a.924.924 0 0 0-.168-.264.924.924 0 0 0-.264-.168.8.8 0 0 0-.608 0 .924.924 0 0 0-.264.168.924.924 0 0 0-.168.264.796.796 0 0 0-.064.304c0 .104.024.208.064.304.04.104.096.184.168.264.08.072.168.128.264.168.096.04.2.064.304.064a.796.796 0 0 0 .304-.064.924.924 0 0 0 .264-.168.826.826 0 0 0 .168-.264c.04-.096.064-.2.064-.304a.796.796 0 0 0-.064-.304z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.13ae23f10376a58344ecaabdd25e7115.svg";
export { ForwardRef as ReactComponent };